import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DropdownMenu } from '@3plearning/react-components';
import { ALL_STUDENTS, STUDENT_LIST } from '../filter-constants';
import { dropdownItemPropType } from '../filter-prop-types';
import dropdownDataSelectors from '../redux/dropdown-data/dropdown-data-selectors';
import dropdownDataActions from '../redux/dropdown-data/dropdown-data-actions';
import {
    getTranslatedOptions,
    getTranslateSelectedOption
} from './dropdown-helpers';

export class StudentDropdown extends PureComponent {
    static propTypes = {
        studentDropdownData: PropTypes.shape({
            data: PropTypes.arrayOf(dropdownItemPropType),
            selectedOption: dropdownItemPropType,
            disabled: PropTypes.bool
        }),
        className: PropTypes.string,
        setSelectedStudent: PropTypes.func,
        handleStudentChange: PropTypes.func
    };

    optionSelected = (selectedOption) => {
        const { handleStudentChange, setSelectedStudent } = this.props;
        setSelectedStudent(selectedOption);
        handleStudentChange();
    };

    render() {
        const { studentDropdownData, className } = this.props;
        const { data, selectedOption, disabled } = studentDropdownData;
        const i18n = window.i18n;

        return (
            <DropdownMenu
                className={className}
                options={getTranslatedOptions(data, ALL_STUDENTS, i18n)}
                selectedOption={getTranslateSelectedOption(
                    selectedOption,
                    ALL_STUDENTS,
                    i18n
                )}
                onSelectOption={this.optionSelected}
                disabled={disabled}
            />
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        studentDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            STUDENT_LIST
        )(state)
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        { setSelectedStudent: dropdownDataActions.setSelectedStudent },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentDropdown);



// WEBPACK FOOTER //
// ./components/report-filters/dropdown-menus/student-dropdown.js